import Vue from 'vue'
import Resource from 'vue-resource'
import VueRouter from 'vue-router'

import routes from './routes'
import store from './store'
// import VueSocketio from 'vue-socket.io'

// Resource logic
Vue.use(Resource)
Vue.http.options.emulateJSON = true

Vue.use(VueRouter)
// Vue.use(VueSocketio, 'http://159.69.19.17:3000')

// Import top level component
import App from './App.vue'

// Routing logic
var router = new VueRouter({
  routes: routes,
  mode: 'history',
  scrollBehavior: function (to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

// Check local storage to handle refreshes
if (window.localStorage) {
  if (store.state.token_log !== window.localStorage.getItem('token_log')) {
    store.commit('SET_TOKEN_LOG', window.localStorage.getItem('token_log'))
  }
  if (store.state.token_header !== window.localStorage.getItem('token_header')) {
    store.commit('SET_TOKEN_HEADER', window.localStorage.getItem('token_header'))
  }
  if (store.state.role !== window.localStorage.getItem('role')) {
    store.commit('SET_ROLE', window.localStorage.getItem('role'))
  }
}

// Some middleware to help us ensure the user is authenticated.
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth) && (store.state.token_log === null)) {
    next('/login')
  } else if ((store.state.token_log !== null) && to.path === '/login') {
    next('/dashboard')
  } else {
    next()
  }
})

window.baseUrl = 'https://services.agar.rs/'
window.baseUrl2 = 'https://agar.rs'

// Start out app!
// eslint-disable-next-line no-new
new Vue({
  el: '#app',
  router: router,
  store: store,
  render: h => h(App)
})

require('bootstrap')
require('eonasdan-bootstrap-datetimepicker')
require('admin-lte')
require('../node_modules/admin-lte/dist/js/demo.js')



// WEBPACK FOOTER //
// ./src/main.js